export const experienceData = [
  {
    id: 1,
    company: "",
    jobtitle: "Fizjoterapeuta w Fizjo- Factory",
    startYear: "",
    endYear: "",
  },
  {
    id: 2,
    company: "",
    jobtitle: "Trener CrossFit Decepticon Gym, Box Ekipa, Wataha",
    startYear: "",
    endYear: "",
  },
  {
    id: 3,
    company: "",
    jobtitle: "Trener Personalny Zdrofit",
    startYear: "",
    endYear: "",
  },
];
